/**
 * Sign-in redirect target.
 *
 * A guard, the session-expiry listener and every share-link action that needs a
 * session all have to send the visitor to the sign-in page and back to where
 * they were. The address is built in one place so the encoding and the
 * parameter name cannot drift between those call sites.
 */

/**
 * Sign-in URL that returns the visitor to one location afterwards.
 *
 * `search` is included because a wizard step is not the same destination
 * without its query string.
 */
export function loginRedirectPath(pathname: string, search = ''): string {
  return `/login/email?redirect=${encodeURIComponent(`${pathname}${search}`)}`
}
